const UrlParser = require('./urlParser');
const parser = new UrlParser();
module.exports = parser;



//////////////////
// WEBPACK FOOTER
// ./node_modules/js-video-url-parser/lib/base.js
// module id = 490
// module chunks = 1